import { Settings } from '../settings';
import { FONTS } from '../constants';
import { BitmapTextStyle } from './BitmapTextStyle';

// Nunito = Nunito Bold
// Asap = Asap Bold
// AsapMedium = Asap Medium

// GAMEPLAY FONTS
export const GridLabel = new BitmapTextStyle({fontName: 'Nunito'});
export const GameLabel = new BitmapTextStyle({fontName: 'Nunito'});
export const GameButton = new BitmapTextStyle({fontName: 'Asap'});
export const GameCoordButton = new BitmapTextStyle({fontName: 'Asap'});
export const CompassNormal = new BitmapTextStyle({fontName: 'Nunito'});
export const CompassActive = new BitmapTextStyle({fontName: 'Nunito'});

// TITLE FONTS
export const PlayButton = new BitmapTextStyle({fontName: 'Asap'});

// SETTINGS FONTS
export const SettingsTitle = new BitmapTextStyle({fontName: 'AsapMedium'});
export const SettingsIntroButton = new BitmapTextStyle({fontName: 'Asap'});
export const SettingsTab = new BitmapTextStyle({fontName: 'AsapMedium'});
export const SettingsTabActive = new BitmapTextStyle({fontName: 'AsapMedium'});
export const SettingsGroupTitle = new BitmapTextStyle({fontName: 'AsapMedium'});
export const OnOffToggle = new BitmapTextStyle({fontName: 'Asap'});
export const SliderLabel = new BitmapTextStyle({fontName: 'AsapMedium'});
export const YesNoToggle = new BitmapTextStyle({fontName: 'Asap'});
export const RadioOption = new BitmapTextStyle({fontName: 'AsapMedium'});
export const TextPreview = new BitmapTextStyle({fontName: 'AsapMedium'});

const AllStyles = {
    GridLabel,
    GameLabel,
    GameButton,
    GameCoordButton,
    CompassNormal,
    CompassActive,
    PlayButton,
    SettingsTitle,
    SettingsIntroButton,
    SettingsTab,
    SettingsTabActive,
    SettingsGroupTitle,
    OnOffToggle,
    SliderLabel,
    YesNoToggle,
    RadioOption,
    TextPreview
};

// Turns out that we don't want all the things to do their color/size with the settings, so
// we are going to whitelist a few rather than go through the work of disconnecting everything.
const enabled:(AllStyleNames)[] = ['GridLabel', 'TextPreview'];

export type AllStyleNames = keyof typeof AllStyles;

function handleSize(value: Settings.TextSize)
{
    // for (const key in AllStyles)
    for (const key of enabled)
    {
        const style = AllStyles[key as AllStyleNames];
        style.fontSize = FONTS[key as AllStyleNames][value];
    }
}

function handleStyle(value: Settings.TextStyle)
{
    // for (const key in AllStyles)
    for (const key of enabled)
    {
        const style = AllStyles[key as AllStyleNames];
        style.tint = FONTS[key as AllStyleNames][value].text;
    }
}

export function listenForChanges(settings:Settings)
{
    settings.textSize.subscribe(handleSize);
    settings.textStyle.subscribe(handleStyle);

    // initialize values
    handleSize(settings.textSize.value);
    handleStyle(settings.textStyle.value);
    // initialize our disconnected font styles
    for (const key in AllStyles)
    {
        if (enabled.includes(key as AllStyleNames)) continue;
        const style = AllStyles[key as AllStyleNames];
        style.fontSize = FONTS[key as AllStyleNames][Settings.TextSize.LARGE];
        style.tint = FONTS[key as AllStyleNames][Settings.TextStyle.WHITE_ON_BLACK].text;
    }
}